import request from '@/utils/request';
import configR from '@/configs.js';
const baseUrl = configR.envConfigs.PORTAL_API;
// 获取事务数量
export function getTodaySchedule(data) {
  return data.request({
    url: `${data.serveUrl}v1/calendar/share/schedule/getTodaySchedule`,
    method: "get",
    headerType: data.header
  });
}
// 日程 - 获取日程列表
export function getScheduleList(params) {
  return request({
    url: baseUrl + "v1/calendar/share/schedule/getEvents",
    method: "get",
    params: params
  });
}
// 日程 - 添加
export function insertSchedule( params) {
  return request({
    url: baseUrl + "v1/calendar/share/schedule/save",
    method: "POST",
    data: params
  });
}
// 日历 - 获取个人日历列表
export function getPersonlCalendar() {
  return request({
    url: baseUrl + "v1/calendar/share/schedule/getPersonlCalendar",
    method: "get"
  });
}
// 日历 -  获取教学周信息
export function getWeekInfo(params) {
  return request({
    url: baseUrl + "v1/calendar/share/schedule/getWeekOfTeaching",
    method: "get",
    params: params
  });
}